import {
	ActivityIndicator,
	SafeAreaView,
	StyleSheet,
	Text,
	TouchableOpacity,
	View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { WebView } from "react-native-webview";
import Feather from "@expo/vector-icons/Feather";
import Loader from "../../components/Loader";
import { PolicyPageWebViewProps } from "./BoardingStack";

const PolicyPageWebView = ({ navigation }: PolicyPageWebViewProps) => {
	const [prog, setProg] = useState(false);
	const [loading, setLoading] = useState(true);
	const [progClr, setProgClr] = useState("#000");
	useEffect(() => {
		// Is necessary to prevent app crashing
		setTimeout(() => {
			setLoading(false);
		}, 500);
	}, []);

	return (
		<SafeAreaView style={{ flex: 1 }}>
			<View style={styles.wbHead}>
				<TouchableOpacity
					style={{ padding: 13 }}
					onPress={() => navigation.goBack()}
				>
					<Feather name={"x"} size={24} />
				</TouchableOpacity>
				<Text
					style={{
						flex: 1,
						textAlign: "center",
						fontSize: 16,
						fontWeight: "bold",
						color: "#00457C",
					}}
				>
					ISIC
				</Text>
				<View style={{ padding: 13, opacity: prog ? 1 : 0 }}>
					<ActivityIndicator size={24} color={progClr} />
				</View>
			</View>
			{!loading ? (
				<WebView
					source={{ uri: "https://www.4schools.io/privacy-policy" }}
					androidLayerType="hardware"
					style={{ flex: 1 }}
					onLoadStart={() => {
						setProg(true);
						setProgClr("#000");
					}}
					onLoadEnd={e => {
						setProg(false);
					}}
					onLoad={() => {
						setProg(false);
					}}
					onError={e => console.log(e)}
				/>
			) : (
				<Loader />
			)}
		</SafeAreaView>
	);
};

export default PolicyPageWebView;

const styles = StyleSheet.create({
	wbHead: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#f9f9f9",
		zIndex: 25,
		elevation: 2,
	},
});
